import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import Config, { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { FiBell } from "react-icons/fi";

import {
  FaCheck,
  FaFileAlt,
} from "react-icons/fa";
import { capitalizeFirstLetter, getDueTypeLabel, hasPermission, truncateText } from "../../helpers";
import Tooltip from "../Tooltip";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const DuesTable = ({
  apiData,
  setSelectedData,
  setShowDueDetails,
  setIsMarkAsPaidVisible,
  canMarkPaymentPaid,
  loadPaymentLinkModal,
  loadingId,
  e,
  setIsViewNotes
}) => {

  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);

  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const user = useSelector((state) => state.UserReducer.user);
  const canMarkPaid = hasPermission("MANANGE_MARK_PAID", user);

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const viewDetail = (item) => {
    setShowDueDetails(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const markPaid = (item) => {
    if (!canMarkPaid) {
      toast.error("You don’t have permission to mark payments as paid");
      return;
    }
    setIsMarkAsPaidVisible(true);
    setSelectedData(item);
  };

  const showPaymentModal = (item, e) => {
    loadPaymentLinkModal(item.id, e);
    setSelectedData(item);
  };

  const notes = (item) => {
    setIsViewNotes(true);
    setSelectedData(item);
    //setOpenActionMenu(null);
  };

  const ActionBtns = (item) => {
    // const isHidden = item.hideFromTenant === 1;

    return (
      <div className="flex items-center gap-3">
        <Tooltip label="Click to view and add notes">
          <button
            onClick={(e) => {
              e.stopPropagation();
              notes(item);
            }}
            className="text-gray-400 hover:text-blue-600 transition"
          >
            <FaFileAlt size={16} />
          </button>
        </Tooltip>
        <Tooltip label="Send payment reminder">
          <button
            // disabled={isHidden}
            onClick={() => showPaymentModal(item, e)}
            className="p-2 rounded-full hover:bg-gray-100 transition cursor-pointer"
          >
            {loadingId === item.id ? (
              <div className="w-4 h-4 border-2 border-gray-300 border-t-transparent rounded-full animate-spin" />
            ) : (
              <FiBell className="text-gray-400" size={18} />
            )}
          </button>
        </Tooltip>
      </div>
    );
  };


  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        getPropName: getPropName(item),
        type: getDuesType(item),
        dueDate: dueDate(item),
        room: item.roomNum + "," + item.flatName,
        amountBalance: getAmount(item),
        rentStartEnd: rentStartEnd(item),
        markAsPaid: markAsPaid(item),
        action: ActionBtns(item),
        originalItem: item
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu, loadingId]);

  const getAmount = (item) => {
    return (
      <Amount onClick={() => viewDetail(item)}>{'₹' + item.balance}</Amount>
    );
  };

  const getName = (item) => {
    const name = capitalizeFirstLetter(item?.tenantName);
    return (
      <UserImageWrapper
        onClick={() =>
          navigate(`/tenantdetails/l/${item.tenantId}`, {
            state: { data: item },
          })
        }>
        <div className="flex-row flex">
          <UserImage src={item.profilePicture ? item.profilePicture : Images.Avatar} alt={`Avatar for ${item.name}`} />
          {(item.kycStatus === 5 || item.kycStatus === 4) &&
            <div className="mt-auto rounded-full bg-green-500 h-4 w-4 flex items-center justify-center -ml-2.5">
              <FaCheck className="text-white" size={10} />
            </div>
          }
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-gray-600 text-sm">
            {truncateText(name, 25)}{""}
          </span>
          <span className="text-gray-400 text-xs">{item?.propertyName ? truncateText(item?.propertyName, 20) : 'N/A'}</span>
        </div>
      </UserImageWrapper>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getDuesTypeOld = (item) => {
    let dueType = getDueTypeLabel(item.type);
    const isOther = dueType?.toUpperCase() === "OTHER";

    return (
      <div className='flex flex-col gap-0'>
        <span className="text-gray-600 text-sm">
          {dueType ? dueType : (item?.title || '')}
        </span>
      </div>
    );
  };

  const getDuesType = (item) => {
    const dueType = getDueTypeLabel(item.type);
    const isOther = dueType?.toUpperCase() === "OTHER";

    const content = (
      <span className="text-gray-600 text-sm">
        {dueType || item?.title || ""}
      </span>
    );

    return (
      <div>
        {isOther ? (
          <Tooltip label={"Due Title - " + item?.title || ""}>
            {content}
          </Tooltip>
        ) : (
          content
        )}
      </div>
    );
  };

  const dueDate = (item) => {
    return (
      <div className="flex flex-col text-sm text-gray-600">
        <span>
          {item.dueDate ? moment(item.dueDate).format("DD, MMM YY") : "---"}
        </span>
      </div>
    );
  };

  const getPropName = (item) => {
    return (
      <div className="flex flex-col">
        <span className="text-zinc-900 font-medium">{item.propName} </span>
      </div>
    );
  };

  const markAsPaid = (item) => {
    return (
      <div className="flex gap-4 ">
        <button
          onClick={() => markPaid(item)}
          className="
            text-sm px-3 py-1 rounded-full
            border border-gray-400 text-gray-500
            hover:bg-gray-100 hover:border-gray-500
            transition"
        >
          Mark as Paid
        </button>
      </div>
    );
  };

  const rentStartEnd = (item) => {
    return (
      <div className="flex flex-col">
        <span>
          R.Start :{" "}
          {item.rentStartDate
            ? moment(item.rentStartDate).format("DD-MM-YYYY")
            : "---"}
        </span>
        <span>
          R.End :{" "}
          {item.rentEndDate
            ? moment(item.rentEndDate).format("DD-MM-YYYY")
            : "---"}
        </span>
      </div>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "For",
          accessor: "type",
        },

        {
          Header: "Balance",
          accessor: "amountBalance",
        },
      ];
    }
    return [
      {
        Header: "For",
        accessor: "type",
      },
      {
        Header: "Balance",
        accessor: "amountBalance",
      },
      // {
      //   Header: "For",
      //   accessor: "type",
      // },
      {
        Header: "Date",
        accessor: "dueDate",
      },

      {
        // Header: canMarkPaymentPaid ? "Mark As Paid" : "",
        // accessor: canMarkPaymentPaid ? "markAsPaid" : "-",
        Heade: "Mark As Paid",
        accessor: "markAsPaid",

      },
      {
        Header: "",
        accessor: "action",
      },
    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {typeof cell.value === "function"
                          ? cell.value()  // render dynamic function
                          : cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2 ">
                        <li>
                          <strong>Due</strong> {data[rowIndex].type}
                        </li>
                        <li>
                          <strong>Due Date</strong> {data[rowIndex].dueDate}
                        </li>
                        {/* {canMarkPaymentPaid &&
                          <li>
                            <strong>Mark ad Paid</strong>{" "}
                            {data[rowIndex].markAsPaid}
                          </li>} */}

                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}


    </>
  );
};

const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer`;
const UserImage = tw.img`w-9 h-9 rounded-full `;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Amount = tw.p`
  text-rose-600 font-semibold
  bg-rose-50 px-3 py-1
  rounded-full inline-flex
  cursor-pointer
`;

export default DuesTable;
